import Eev from "eev";
import initIntroJS from "./intro-tour";

interface MultilevelNode {
  data: string;
  label: string;
  id?: string;
  type?: string;
  link?: string;
  icon?: string;
  primaryColor?: string;
  secondaryColor?: string;
  logoName?: string;
  items?: MultilevelNode[];
}


function checkAuthorization(item: MultilevelNode, authorization: string[]) {
  return (authorization.indexOf(item.data) >= 0)
}

function validItems(item: MultilevelNode) {
  return item.items && item.items.length > 0
}

function verifyMicrofrontend(mf: MultilevelNode, authorization: string[]): MultilevelNode {
  // Check if it's the home page or passes authorization
  if (mf.data === 'home' || (mf.type === 'page' && checkAuthorization(mf, authorization))) {
    return mf;
  }

  // Log a warning for containers with no items
  if (mf.type === 'container' && (!mf.items || mf.items.length === 0)) {
    console.warn(`Warning: Container '${mf.label}' with data '${mf.data}' has no items.`);
    return mf;
  }

  // Filter and recursively verify items
  mf.items = (mf.items || []).reduce((acc, mfItem) => {
    if (mfItem.type === 'page' && (mfItem.data === 'home' || checkAuthorization(mfItem, authorization))) {
      acc.push(mfItem);
    } else if (mfItem.type === 'container' && validItems(mfItem)) {
      const verifiedItem = verifyMicrofrontend(mfItem, authorization);
      if (verifiedItem) {
        acc.push(verifiedItem);
      }
    }
    return acc;
  }, [])
    .map(it => {
      if(it.items) {
        it.items = it.items.filter(fl => (validItems(fl) || fl.items === undefined));
      }
      return it;
    });

  return mf;
}

function getAuthorizedSuiteItemsOnly(suite: MultilevelNode, authorization: any) {
  const validMicrofrontends = suite.items
    .filter((item: MultilevelNode) => item.data.includes('home') || authorization[item.data]);
  suite.items = validMicrofrontends
    .map((mf: MultilevelNode) => verifyMicrofrontend(mf, authorization[mf.data]))
    .map(it => {
      if(it.items) {
        it.items = it.items.filter(fl => (validItems(fl) || fl.items === undefined));
      }
      return it;
    });
  return suite;
}

function getSuiteName(suitesList: any, mountedApp: string) {
  const suiteTree = {};
  for (const cur in suitesList) {
    const {data, items} = suitesList[cur];
    suiteTree[data] = items.map((i: any) => i.data);
  }
  for (const key in suiteTree) {
    if (suiteTree[key].includes(mountedApp)) {
      return key;
    }
  }
  return null;
}

function loadThigsAfterContentLoad() {
  setTimeout(async () => {
    // initIntroJS();
    // setta la classe che permette di ridimensionare la larghezza tenendo conto della sidenav
    const mfContent = document.getElementsByTagName("mat-sidenav-content");
    if(mfContent.length > 0) {
      mfContent[0].classList.add('content-with-sidenav');
    }
  }, 500);
}

export function initRoutingEventsManager(appPrefix: string, eventBus: Eev, suitesList, authorization) {
  window.addEventListener('single-spa:routing-event', ({detail}: CustomEvent) => {
    console.log('single-spa routing event', `singleSpaTrigger: ${!!detail.originalEvent ? detail.originalEvent.singleSpaTrigger : detail.originalEvent}`, detail);

    const processBootstrapRoutingEvent = (eventType: string, mountedApp: string, suiteKey = undefined) => {
      const suiteName = suiteKey || getSuiteName(suitesList, mountedApp);
      const selectedSuite = suitesList[suiteName];
      if (selectedSuite) {
        console.log("processBootstrapRoutingEvent", eventType)

        const authorizedSuiteItems = getAuthorizedSuiteItemsOnly(Object.assign({}, selectedSuite), authorization);
        eventBus.emit(`bootstrap:${eventType}-event`, {
          mountedApp,
          suiteName,
          selectedSuite: authorizedSuiteItems
        });
        console.debug({mountedApp, suiteName, selectedSuite});
      }
    };

    // caricamento di un nuovo microfrontend
    if (detail && detail.totalAppChanges !== 0 && detail.appsByNewStatus.MOUNTED.length > 0) {
      console.log(`triggering bootstrap:mount-event`)
      loadThigsAfterContentLoad();
      const mountedApp = detail.appsByNewStatus.MOUNTED.pop().replace(`${appPrefix}/`, '');
      const urlPathname = (new URL(detail.newUrl)).pathname.split('/');
      if(mountedApp.includes('home') && urlPathname[2] && urlPathname[2].length) {
        const mountedApp = urlPathname[1];
        console.log(`triggering bootstrap:suite-selection-event for home`)
        const suiteName = urlPathname[2] && urlPathname[2].length ? urlPathname[2] : 'trasversale';
        processBootstrapRoutingEvent('mounted', mountedApp);
        processBootstrapRoutingEvent('suite-selection', mountedApp, suiteName);
      } else {
        processBootstrapRoutingEvent('mounted', mountedApp);
      }
    }

    // pushState() è' un metodo dell'interfaccia History che aggiunge una voce nella session history stack del browser.
    // Nel custom event emesso da singlespa sono presenti due tipologie di singleSpaTrigger: replaceState e pushState
    // In questo caso viene selezionato uno dei due per emettere l'avvenuto trigger di mount di un microfrontend
    // && detail.originalEvent.singleSpaTrigger === 'pushState'
    // cambio suite all'interno del microfrontend home
    if (detail.newUrl && detail.originalEvent !== undefined) {
      const urlPathname = (new URL(detail.newUrl)).pathname.split('/');
      const mountedApp = urlPathname[1];
      if (mountedApp === 'home' && urlPathname.length >= 2 && detail.originalEvent.singleSpaTrigger === 'pushState') {
        console.log(`triggering bootstrap:suite-selection-event`)
        const suiteName = urlPathname[2] && urlPathname[2].length ? urlPathname[2] : 'trasversale';
        processBootstrapRoutingEvent('suite-selection', mountedApp, suiteName);
      }
    }

  });
}
